module.exports = __webpack_public_path__ + "static/media/FIUSCIS.97e8391a.svg";